import React from "react";
import moment from "moment";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableRow,
  Checkbox,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AccordionDetails,
  Accordion,
  AccordionSummary,
  FormControlLabel,
  Tooltip,
  DialogContentText,
  Button
} from "@material-ui/core";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/VisibilityOutlined";
import HistoryOutlined from "@material-ui/icons/HistoryOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "./configuration.less";
import AddBoxIcon from "@material-ui/icons/AddBox";
import {
  apiRequest,
  apiBatchRequest,
  apiPost,
  apiRequestAsync
} from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import SaveIcon from "@material-ui/icons/Save";
import BackIcon from "@material-ui/icons/BackspaceRounded";

import "./configuration.less";
import commonLabels from "../../constants/messageConstants";
import { ShowToast, toastType } from "../../utils/toast-service";
import DatePicker from "react-datepicker";
import { removeDuplicates, GetSectionPermission } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
export default class FacilityPerformanceReportMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: [],
      selectedDatacenter: 1,
      performanceReports: [],
      performanceReportAttribute: [],
      isInEditView: false,
      addNewReport: false,
      selectedReportId: 0,
      selectedReportName: "",
      operatorList: [],
      serviceLocationsList: [],
      serviceLocationSideList: [],
      pointList: [],
      isLoadHistoryOpen: false,
      historicalEndDate: false,
      historicalStartDate: false,
      performanceLookUpAttributes: [],
      performanceLookUpMasterTables: [],
      calculationFieldAttributes: []
    };
  }

  componentWillMount() {}

  /**
   * get required master data
   */
  componentDidMount() {
    this.GetDataCenterList();
    this.GetPerformanceReportListByProperty();
  }

  /**
   * Return performance report list information by property
   */
  GetPerformanceReportListByProperty = () => {
    const { selectedDatacenter } = this.state;
    // console.log("List Updated");
    apiRequest({
      url:
        API_URL.performance.GetPerformanceReportListByProperty +
        "?propertyId=" +
        selectedDatacenter
    }).then(({ data: response }) => {
      this.setState({
        performanceReports: response || [],
        isInEditView: false,
        addNewReport: false,
        selectedReportId: 0
      });
    });
  };

  /**
   * get data center list
   */
  GetDataCenterList = () => {
    apiBatchRequest([
      {
        url: API_URL.datacenter.getDatacenterList,
        key: "response"
      },
      {
        url: API_URL.masterData.GetBmsSource,
        key: "sourceList"
      }
    ]).then(({ response }) => {
      this.setState({
        datacenterList: (response || {}).data || [],
        // sourceList: (sourceList || {}).data || []
      });
    });
  };

  /**
   * call on handle report change
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   */
  handelReportChange = (value, key, index) => {
    const { performanceReports } = this.state;

    performanceReports[index][key] = value;
    this.setState({ performanceReports: performanceReports });
  };

  /**
   * Save performance report
   * @returns 
   */
  SavePerformanceReports = () => {
    const { performanceReports, selectedDatacenter } = this.state;
    if (selectedDatacenter === 0 || selectedDatacenter === undefined) {
      ShowToast(
        "Please select data center",
        toastType.ERROR,
        5000,
        commonLabels.somethingWrong.code
      );
      return;
    }

    const names = [];
    performanceReports.forEach(function(x) {
      x.dataCenterId = selectedDatacenter;
      if (isNaN(x.reportSortOrder)) {
        names.push(" " + x.reportName);
      }
    });

    if (names.length > 0) {
      const message = names.toString();
      ShowToast(
        "Please enter sort order for" + message + ".",
        toastType.ERROR,
        5000,
        commonLabels.somethingWrong.code
      );

      return false;
    }
    apiPost({
      url: API_URL.performance.UpdatePerformanceReports,
      postBody: performanceReports,
      params: { propertyId: selectedDatacenter }
    }).then(({ success: isExecuted }) => {
      if (isExecuted == true) {
        this.GetPerformanceReportListByProperty();
        ShowToast(
          "Performance views updated successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
      } else
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
    });
  };

  /**
   * Render body 
   * @returns 
   */
  renderBody = () => {
    const permission = GetSectionPermission(
      SECTIONS.CONFIGURATION,
      SECTIONS.CONFIGURE_FACILITY_PERFORMANCE
    );
    const IsEditable = permission.accessTypeId > 1 ? true : false;

    if (this.state.isInEditView) {
      return this.getReportEditView();
    }
    return this.getMainListView(IsEditable);
  };

  /**
   * Load edit report data
   * @param {*} row 
   * @param {*} addNewReport 
   */
  LoadEditReportData = (row, addNewReport) => {
    const params = {
      propertyId: this.state.selectedDatacenter,
      reportId: row.reportId
    };

    apiBatchRequest([
      {
        url: API_URL.performance.GetPerformanceReportAttribute,
        params,
        key: "performanceReportAttribute"
      },
      {
        url: API_URL.masterData.GetOperators,
        key: "operatorList"
      },
      {
        url:
          API_URL.masterData.GetServiceLocations +
          "?propertyId=" +
          params.propertyId,
        key: "serviceLocationsList"
      },
      {
        url: API_URL.masterData.GetServiceLocationSides,
        key: "serviceLocationSideList"
      },
      {
        url:
          API_URL.masterData.GetPointList + "?propertyId=" + params.propertyId,
        key: "pointList"
      },
      {
        url: API_URL.performance.GetPerformanceLookUpAttributes,
        key: "performanceLookUpAttributes"
      },
      {
        url: API_URL.performance.GetPerformanceLookUpMasterTables,
        key: "performanceLookUpMasterTables"
      }
    ]).then(
      ({
        performanceReportAttribute,
        operatorList,
        serviceLocationsList,
        serviceLocationSideList,
        pointList,
        performanceLookUpAttributes,
        performanceLookUpMasterTables
      }) => {
        // console.log("ROW", row);
        const calculationFieldAttributes = removeDuplicates(
          ((performanceReportAttribute || {}).data || []).map(a => ({
            attributeName: a.attributeName,
            attributeListId: a.attributeListId
          })),
          "attributeListId"
        );
        this.setState({
          performanceReportAttribute:
            (performanceReportAttribute || {}).data || [],
          operatorList: (operatorList || {}).data || [],
          serviceLocationsList: (serviceLocationsList || {}).data || [],
          serviceLocationSideList: (serviceLocationSideList || {}).data || [],
          pointList: (pointList || {}).data || [],
          selectedReportId: row.reportId,
          selectedReportName: row.reportName,
          isInEditView: true,
          addNewReport: addNewReport,
          performanceLookUpAttributes: performanceLookUpAttributes.data || [],
          performanceLookUpMasterTables:
            performanceLookUpMasterTables.data || [],
          calculationFieldAttributes: calculationFieldAttributes || []
        });
      }
    );
  };

  // refreshAttributeList = () => {
  //   const params = {
  //     propertyId: this.state.selectedDatacenter,
  //     reportId: this.state.selectedReportId,
  //   };
  //   apiRequest({
  //     url: API_URL.performance.GetPerformanceReportAttribute,
  //     params,
  //   }).then(({ data: performanceReportAttribute }) => {
  //     this.setState({
  //       performanceReportAttribute: performanceReportAttribute,

  //       isLoading: false,
  //     });
  //   });
  // };

  /**
   * Return main list view 
   * @param {*} IsEditable 
   * @returns 
   */
  getMainListView = IsEditable => {
    const loadHistoricalData = GetSectionPermission(
      SECTIONS.CONFIGURATION,
      SECTIONS.LOAD_HISTORICAL_DATA
    );

    const {
      datacenterList,
      performanceReports,
      selectedDatacenter
    } = this.state;
    return (
      <TableBody>
        <TableRow>
          <TableCell key={"configurableCell"}>
            <div className={"col-xs-12"}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel size={"small"} id={"WidgetTypeLabel"}>
                  {"Data center\r"}
                </InputLabel>
                <Select
                  required
                  style={{ width: "100%" }}
                  labelId={"WidgetTypeLabel"}
                  id={"WidgetTypeLabelSelect"}
                  value={selectedDatacenter || ""}
                  defaultValue={selectedDatacenter}
                  onChange={event => {
                    this.setState(
                      { selectedDatacenter: event.target.value },
                      () => this.GetPerformanceReportListByProperty()
                    );
                  }}
                  placeholder={"Select Data center"}
                >
                  {datacenterList.map((dc, index) => (
                    <MenuItem key={"menu"+index} size={"medium"} value={dc.propertyID}>
                      {dc.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>{" "}
          </TableCell>
        </TableRow>
        <br />
        <TableRow>
          <TableCell
            key={"configureChildHeader"}
            className={"content-header sub-section row co-xs-12"}
          >
            <div className={"content-header row col-xs-12"}>
              {"Performance Views\r"}
              <div className={"end-xs col-xs"}>
                {/* <IconButton
                  color="inherit"
                  size="small"
                  onClick={()=>{this.setState({openCustomizedLayout:true});}}
                >
                  <SaveIcon fontSize="small"></SaveIcon>
                </IconButton> */}
                {IsEditable && (
                  <>
                    <Tooltip title={"Save Changes"}>
                      <IconButton
                        className={"white-button"}
                        color={"inherit"}
                        size={"small"}
                        onClick={this.SavePerformanceReports}
                      >
                        <SaveIcon
                          className={"white-button"}
                          fontSize={"small"}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={"Add New Report"}>
                      <IconButton
                        className={"white-button"}
                        aria-label={"newReport"}
                        size={"small"}
                        onClick={() => {
                          if (selectedDatacenter > 0) {
                            // this.setState({
                            //   isInEditView: true,
                            //   addNewReport: true,
                            // });
                            this.LoadEditReportData(
                              { reportId: 0, reportName: "" },
                              true
                            );
                            this.addNewAttribute(
                              null,
                              null,
                              this.state.performanceReportAttribute.length + 1
                            );
                          } else {
                            ShowToast(
                              "Please select data center",
                              toastType.ERROR,
                              5000,
                              commonLabels.somethingWrong.code
                            );
                          }
                        }}
                      >
                        <AddCircleOutline fontSize={"small"} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}{" "}
              </div>
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell key={"configureHeaderCell2"}>
            <div className={"col-xs-12"}>
              <TableContainer>
                <Table
                  aria-labelledby={"tableTitle"}
                  size={"small"}
                  aria-label={"enhanced table"}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell key={"ReportName"}>{" View Name "}</TableCell>
                      <TableCell key={"source"}>{" Source "}</TableCell>
                      <TableCell key={"order"}>{" Display Order "}</TableCell>
                      <TableCell key={"IsAccessible"}>{" Is Active "}</TableCell>
                      <TableCell key={"Action"}>{" Action"}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {performanceReports.map((row, index) => {
                      return (
                        <TableRow key={row.name}>
                          <TableCell key={"TCReportName" + index}>
                            {" "}
                            <TextField
                              disabled={!IsEditable}
                              id={"reportName" + index}
                              key={"reportName" + index}
                              size={"small"}
                              label={""}
                              fullWidth
                              value={row.reportName}
                              onChange={event => {
                                this.handelReportChange(
                                  event.target.value,
                                  "reportName",
                                  index
                                );
                              }}
                            />
                          </TableCell>
                          <TableCell key={"TCSourceSystem" + index}>
                            {" "}
                            {row.sourceSystem}{" "}
                          </TableCell>
                          <TableCell key={"TCSortOrder" + index}>
                            {" "}
                            <TextField
                              disabled={!IsEditable}
                              type={"number"}
                              label={""}
                              id={"reportSortOrder" + index}
                              key={"reportSortOrder" + index}
                              size={"small"}
                              fullWidth
                              value={row.reportSortOrder}
                              onChange={event => {
                                this.handelReportChange(
                                  parseInt(event.target.value),
                                  "reportSortOrder",
                                  index
                                );
                              }}
                            />
                          </TableCell>
                          <TableCell key={"TCIsActive" + index}>
                            <Checkbox
                              disabled={!IsEditable}
                              id={"ChkIsActive" + index}
                              key={"ChkIsActive" + index}
                              color={"primary"}
                              value={row.isActive}
                              checked={row.isActive}
                              onChange={event => {
                                event.target.checked;
                                this.handelReportChange(
                                  event.target.checked,
                                  "isActive",
                                  index
                                );
                              }}
                            />{" "}
                          </TableCell>
                          <TableCell key={"TCAction" + index}>
                            <Tooltip
                              title={IsEditable ? "Edit Record" : "View Record"}
                            >
                              <IconButton
                                aria-label={"Edit"}
                                size={"small"}
                                onClick={() => {
                                  this.LoadEditReportData(row);
                                }}
                              >
                                {IsEditable ? (
                                  <EditIcon size={"small"} />
                                ) : (
                                  <ViewIcon size={"small"} />
                                )}
                              </IconButton>
                            </Tooltip>
                            {IsEditable &&
                              (loadHistoricalData.accessType != "Hidden" ? (
                                <Tooltip title={"Load Historical Data"}>
                                  <IconButton
                                    aria-label={"loadHistorical"}
                                    size={"small"}
                                    onClick={() => {
                                      this.setState({
                                        selectedReportName: row.reportName,
                                        selectedReportId: row.reportId,
                                        isLoadHistoryOpen: true
                                      });
                                      //this.LoadEditReportData(row);
                                    }}
                                  >
                                    <HistoryOutlined size={"small"} />
                                  </IconButton>
                                </Tooltip>
                              ) : null)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  };

  /**
   * get report edit view
   * @returns 
   */
  getReportEditView = () => {
    const {
      datacenterList,
      selectedDatacenter,
      selectedReportName,
      isInEditView,
      addNewReport
    } = this.state;

    const permission = GetSectionPermission(
      SECTIONS.CONFIGURATION,
      SECTIONS.CONFIGURE_FACILITY_PERFORMANCE
    );

    const IsEditable = permission.accessTypeId > 1 ? true : false;
    const IsDeletable = permission.accessTypeId > 2 ? true : false;

    if (isInEditView) {
      return (
        <TableBody>
          <TableRow>
            <TableCell key={"configurableCell"}>
              <div className={"col-xs-12"}>
                <TextField
                  disabled={!addNewReport || !IsEditable}
                  id={"ReportTitle"}
                  key={"ReportTitle"}
                  label={"Report Title"}
                  size={"small"}
                  fullWidth
                  defaultValue={selectedReportName}
                  onChange={event => {
                    this.setState({ selectedReportName: event.target.value });
                    this.handleReportAttributeChange(
                      event.target.value,
                      "reportName",
                      0
                    );
                  }}
                />
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell key={"configurableCell"}>
              <div className={"col-xs-12"}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel size={"small"} id={"WidgetTypeLabel"}>
                    {"Data center\r"}
                  </InputLabel>
                  <Select
                    required
                    disabled
                    style={{ width: "100%" }}
                    labelId={"WidgetTypeLabel"}
                    id={"WidgetTypeLabelSelect"}
                    defaultValue={selectedDatacenter}
                    placeholder={"Select Data center"}
                  >
                    {datacenterList.map((dc, index) => (
                      <MenuItem key={"WidgetTypeLabelSelectMenu"+index} size={"medium"} value={dc.propertyID}>
                        {dc.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>{" "}
            </TableCell>
          </TableRow>
          <br />
          <TableRow>
            <TableCell
              key={"configureChildHeader"}
              className={"content-header sub-section row co-xs-12"}
            >
              <div className={"content-header row col-xs-12"}>
                {"View Attributes\r"}
                <div className={"end-xs col-xs"}>
                  {IsEditable && (
                    <Tooltip title={"Add New Attribute"}>
                      <IconButton
                        className={"white-button"}
                        aria-label={"autoGenerateFilter"}
                        size={"small"}
                        onClick={() => this.addNewAttribute(null, null)}
                      >
                        <AddCircleOutline fontSize={"small"} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {IsEditable && (
                    <Tooltip title={"Add New Attribute"}>
                      <IconButton
                        color={"inherit"}
                        size={"small"}
                        onClick={this.updateAttributeList}
                      >
                        <SaveIcon
                          className={"white-button"}
                          fontSize={"small"}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              key={"configureChildHeader"}
              className={"  sub-section row co-xs-12"}
            >
              {this.getAttributeRow(IsEditable, IsDeletable)}
            </TableCell>
          </TableRow>
        </TableBody>
      );
    } else {
      return <></>;
    }
  };

  /**
   * Update attribute list
   * @returns 
   */
  updateAttributeList = () => {
    const UpdateArray = this.state.performanceReportAttribute;

    const MessagesFor = [];
    UpdateArray.forEach((xObj) => {
      if (
        xObj.attributeName == null ||
        xObj.operatorId == 0 ||
        xObj.serviceSideId == null ||
        xObj.serviceLocationId == 0 ||
        xObj.reportName == null ||
        (xObj.isStatic == false && xObj.pointListId == 0) ||
        (xObj.isStatic == true &&
          (xObj.staticAttributeValue == null ||
            xObj.staticAttributeValue == ""))
      ) {
        if (xObj.statusId == 1) {
          MessagesFor.push(xObj.reportName);
        }
      }
    });

    if (MessagesFor.length > 0) {
      ShowToast(
        "Please enter details in all fields including attribute titles.",
        toastType.ERROR,
        5000,
        commonLabels.somethingWrong.code
      );
      return false;
    }

    apiPost({
      url: API_URL.performance.UpdateAttribute,
      postBody: this.state.performanceReportAttribute
    }).then(({ success: isExecuted }) => {
      if (isExecuted == true) {
        ShowToast(
          "Performance view attribute updated successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
        this.GetPerformanceReportListByProperty();
      } else
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
    });
  };

  /**
   * get attribute for row
   * @param {*} IsEditable 
   * @param {*} IsDeletable 
   * @returns 
   */
  getAttributeRow = (IsEditable, IsDeletable) => {
    const { performanceReportAttribute } = this.state;
    // console.log("Attribute", performanceReportAttribute);
    const tableRow = [];
    let mainAttribute = {};
    let previousAttribute = -1;
    let childRow = [];
    let lastindex = false;
    let accordion = <></>;
    let accordionDetails = <></>;
    performanceReportAttribute.map((attribute, index) => {
      let parentIndex = 0;
      const nextAttribute = performanceReportAttribute[index + 1]
        ? performanceReportAttribute[index + 1].attributeName
        : "";

      mainAttribute = { ...attribute };
      if (
        mainAttribute.attributeName !== nextAttribute ||
        index == performanceReportAttribute.length - 1
      ) {
        lastindex = true;
      }
      if (mainAttribute.attributeName != previousAttribute) {
        if (childRow.length > 0) {
          // console.log(index);
          accordionDetails = (
            <AccordionDetails className={"row"}>{[...childRow]}</AccordionDetails>
          );
          childRow = [];
          tableRow.push(
            <Accordion>
              {accordion}
              {accordionDetails}
            </Accordion>
          );
        }
        parentIndex = index;

        accordion = (
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={"Column-content" + index}
            id={"panel-header" + index}
          >
            {" "}
            {this.getHeaderAttributeRow(
              mainAttribute,
              index,
              attribute.isKeyAttribute,
              IsEditable,
              IsDeletable
            )}
          </AccordionSummary>
        );
      }
      if (attribute.statusId == 1) {
        childRow.push(
          this.getChildAttributeRow(
            attribute,
            parentIndex,
            index,
            lastindex,
            IsEditable,
            IsDeletable
          )
        );
      }

      if (index == performanceReportAttribute.length - 1) {
        // console.log(index);
        accordionDetails = (
          <AccordionDetails className={"row"}>{[...childRow]}</AccordionDetails>
        );

        tableRow.push(
          <Accordion>
            {accordion}
            {accordionDetails}
          </Accordion>
        );
      }

      lastindex = false;
      previousAttribute = mainAttribute.attributeName;
    });

    return tableRow;
  };

  /**
   * Add new attribute
   * @param {*} ToAddAttributeName 
   * @param {*} attributeListIdValue 
   * @param {*} isStatic 
   * @param {*} isLookup 
   * @param {*} isCalculationBasedOnAttribute 
   * @param {*} index 
   */
  addNewAttribute = (
    ToAddAttributeName,
    attributeListIdValue,
    isStatic,
    isLookup,
    isCalculationBasedOnAttribute,
    index
  ) => {
    const {performanceReportAttribute ,
    selectedDatacenter,
     selectedReportId ,
     selectedReportName }= this.state;
    // console.log(this.state.selectedDatacenter);

    performanceReportAttribute.splice(index, 0, {
      attributeListId: attributeListIdValue ? attributeListIdValue : 0,
      attributeName: ToAddAttributeName ? ToAddAttributeName : "",
      attributeSortOrder: 0,
      calculationAttributeId: 0,
      dataCenterId: selectedDatacenter,
      isKeyAttribute: false,
      isStatic: isStatic,
      isLookup: isLookup,
      isCalculationBasedOnAttribute: isCalculationBasedOnAttribute,
      operatorId: 0,
      operatorName: "",
      parentReportId: performanceReportAttribute[0].parentReportId ? performanceReportAttribute[0].parentReportId : 0,
      parentReportName: performanceReportAttribute[0].parentReportName
        ? performanceReportAttribute[0].parentReportName
        : "",
      pointDisplayName: null,
      pointListId: 0,
      pointMappingId: 0,
      pointName: null,
      reportId: selectedReportId,
      reportName: selectedReportName,
      sectionDetailId: 0,
      serviceLocation: "",
      serviceLocationId: 0,
      serviceSideId: 0,
      staticAttributeValue: "",
      statusId: 1
    });
    // console.log("NewObj", addObj);
    this.setState({
      performanceReportAttribute: performanceReportAttribute
    });
    this.getReportEditView();
  };

  /**
   * call on delete click
   * @param {*} index 
   * @param {*} type 
   */
  handelDelete = (index, type) => {
    // console.log(index, type);

    const {performanceReportAttribute} = this.state;
    // console.log(objToDel);
    if (type == "index") {
      performanceReportAttribute[index].statusId = 2;
    } else if (type == "attributeName") {
      (performanceReportAttribute || []).map((item, arrayIndex) =>
        item.attributeName == index ? (performanceReportAttribute[arrayIndex].statusId = 2) : 1
      );
      // console.log(objToDel);
    }

    // console.log(objToDel);
    this.setState({
      performanceReportAttribute: performanceReportAttribute
    });
  };

  /**
   * get header attribute row
   * @param {*} mainAttribute 
   * @param {*} index 
   * @param {*} isKey 
   * @param {*} IsEditable 
   * @param {*} IsDeletable 
   * @returns 
   */
  getHeaderAttributeRow = (
    mainAttribute,
    index,
    isKey,
    IsEditable,
    IsDeletable
  ) => {
    return (
      <div className={"row col-xs-12"}>
        <div className={"start-xs col-xs-1"}>
          {IsDeletable ? (
            <IconButton
              color={"inherit"}
              size={"small"}
              onClick={() =>
                this.handelDelete(mainAttribute.attributeName, "attributeName")}
            >
              <DeleteIcon fontSize={"small"} />
            </IconButton>
          ) : null}
        </div>
        <div className={"row col-xs-4"}>
          {mainAttribute.attributeName != "" ? (
            <>
              <TextField
                disabled={!IsEditable}
                key={mainAttribute.attributeName + index}
                defaultValue={mainAttribute.attributeName}
                id={"standard-basic" + index}
                label={"Attribute Title"}
                fullWidth
                className={"col-xs-12"}
                onBlur={event => {
                  this.handleReportAttributeChange(
                    event.target.value,
                    "attributeName",
                    index
                  );
                }}
              />
            </>
          ) : (
            <TextField
              disabled={!IsEditable}
              key={mainAttribute.attributeName + index}
              defaultValue={mainAttribute.attributeName}
              id={"standard-basic" + index}
              label={"Attribute Title"}
              fullWidth
              className={"col-xs-12"}
              onBlur={event => {
                this.handleReportAttributeChange(
                  event.target.value,
                  "attributeName",
                  index
                );
              }}
            />
          )}
        </div>
        <div className={"row col-xs-2"}>
          <FormControlLabel
            id={"IsStaticControlLabel" + index}
            key={"IsStaticControlLabelKey" + index}
            value={mainAttribute.isStatic || false}
            checked={mainAttribute.isStatic}
            onClick={event => event.stopPropagation()}
            control={
              <Checkbox
                disabled={!IsEditable}
                id={"isStatic" + index}
                color={"primary"}
                onChange={event => {
                  event.preventDefault();
                  this.handelReportKayChange(
                    event.target.checked,
                    "isStatic",
                    index,
                    mainAttribute.attributeName
                  );
                }}
              />
            }
            size={"small"}
            label={"Is Static"}
            labelPlacement={"end"}
          />
        </div>
        <div className={"row col-xs-3"}>
          <FormControlLabel
            id={"IsLookupControlLabel" + index}
            key={"IsLookupControlLabelKey" + index}
            value={mainAttribute.isLookup || false}
            checked={mainAttribute.isLookup}
            onClick={event => event.stopPropagation()}
            control={
              <Checkbox
                disabled={!IsEditable}
                id={"isLookup" + index}
                color={"primary"}
                onChange={event => {
                  event.preventDefault();
                  this.handelReportKayChange(
                    event.target.checked,
                    "isLookup",
                    index,
                    mainAttribute.attributeName
                  );
                }}
              />
            }
            size={"small"}
            label={"Look Up Field"}
            labelPlacement={"end"}
          />
        </div>

        <div className={"row col-xs-2"}>
          <FormControlLabel
            id={"isCalculationBasedOnAttributeLabel" + index}
            key={"isCalculationBasedOnAttributeLabelKey" + index}
            value={mainAttribute.isCalculationBasedOnAttribute || true}
            checked={mainAttribute.isCalculationBasedOnAttribute}
            onClick={event => event.stopPropagation()}
            control={
              <Checkbox
                disabled={!IsEditable}
                id={"isCalculationBasedOnAttribute" + index}
                color={"primary"}
                onChange={event => {
                  this.handelReportKayChange(
                    event.target.checked,
                    "isCalculationBasedOnAttribute",
                    index,
                    mainAttribute.attributeName
                  );
                }}
              />
            }
            size={"small"}
            label={"Calculation Based On Attribute"}
            labelPlacement={"end"}
          />
        </div>
      </div>
    );
  };

  /**
   * call on report attribute change
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   */
  handleReportAttributeChange = (value, key, index) => {
    const {performanceReportAttribute} = this.state;
    const { calculationFieldAttributes } = this.state;
    performanceReportAttribute[index][key] = value;

    if (key == "pointListId") {
      const pointArray = this.state.pointList;
      const found = pointArray.find(element => element.pointListId == value);
      performanceReportAttribute[index]["pointDisplayName"] =
        found.pointDisplayName;
      performanceReportAttribute[index]["pointName"] = found.pointName;
    }
    if (key == "attributeName") {
      if (performanceReportAttribute[index]["attributeListId"] == 0) {
        calculationFieldAttributes.push[
          {
            attributeName: value,
            attributeListId: -index
          }
        ];
      } else {
        calculationFieldAttributes
          .find(
            x =>
              x.attributeListId ==
                performanceReportAttribute[index]["attributeListId"] ||
              x.attributeListId == -index
          )
          .forEach(x => (x.attributeName = value));
      }
    }

    this.setState({
      performanceReportAttribute: performanceReportAttribute
    });
  };

  /**
   * call on report key change
   * @param {*} value 
   * @param {*} key 
   * @param {*} index 
   * @param {*} getAttributeName 
   */
  handelReportKayChange(value, key, index, getAttributeName) {
    const {performanceReportAttribute} = this.state;
    performanceReportAttribute.map((dc, indexInner) => {
      if (dc.attributeName == getAttributeName) {
        performanceReportAttribute[indexInner][key] = value;
        if (key == "isStatic" && value == true) {
          performanceReportAttribute[indexInner]["pointListId"] = 0;
          performanceReportAttribute[indexInner]["pointDisplayName"] = null;
          performanceReportAttribute[indexInner]["pointName"] = null;
          performanceReportAttribute[indexInner]["pointMappingId"] = 0;
          performanceReportAttribute[indexInner]["isLookup"] = false;
          performanceReportAttribute[indexInner]["lookupTableId"] = null;
          performanceReportAttribute[indexInner]["lookupOnFieldId"] = null;
          performanceReportAttribute[indexInner]["lookupFieldId"] = null;
          performanceReportAttribute[indexInner]["false"] = true;
        } else if (key == "isStatic" && value == false) {
          performanceReportAttribute[indexInner]["staticAttributeValue"] = null;
        }
        if (key == "isLookup" && value == true) {
          performanceReportAttribute[indexInner]["isStatic"] = false;
          performanceReportAttribute[indexInner]["isKeyAttribute"] = true;
          performanceReportAttribute[indexInner]["staticAttributeValue"] = null;
          performanceReportAttribute[indexInner][
            "isCalculationBasedOnAttribute"
          ] = true;
        } else if (key == "isLookup" && value == false) {
          performanceReportAttribute[indexInner]["lookupTableId"] = null;
          performanceReportAttribute[indexInner]["lookupOnFieldId"] = null;
          performanceReportAttribute[indexInner]["lookupFieldId"] = null;
          performanceReportAttribute[indexInner][
            "isCalculationBasedOnAttribute"
          ] = false;
        }
      }
    });

    this.setState({
      performanceReportAttribute: performanceReportAttribute
    });
  }

  /**
   * get child Attribute row
   * @param {*} attribute 
   * @param {*} parentIndex 
   * @param {*} childIndex 
   * @param {*} isLastRow 
   * @param {*} IsEditable 
   * @param {*} IsDeletable 
   * @returns 
   */
  getChildAttributeRow = (
    attribute,
    parentIndex,
    childIndex,
    isLastRow,
    IsEditable,
    IsDeletable
  ) => {
    const {
      operatorList,
      serviceLocationsList,
      serviceLocationSideList,
      performanceLookUpAttributes,
      performanceLookUpMasterTables,
      calculationFieldAttributes
    } = this.state;

    const pointCalculationAttributeDisplayName = (
      this.state.pointList.find(
        x => x.pointListId == attribute.calculationAttributeId
      ) || {}
    ).pointDisplayName;
    return (
      <>
        {/* {console.log(attribute.attributeName)} */}
        <div className={" row col-xs-12 performance-attr-child"}>
          <div
            className={"col-xs-12"}
            style={{ display: "flex" }}
            key={"mapping" + childIndex}
          >
            {attribute.isStatic || false == true ? (
              <div className={"col-xs"} style={{ padding: "3px" }}>
                {" "}
                <TextField
                  disabled={!IsEditable}
                  key={"pointName" + childIndex}
                  label={"Static Value"}
                  fullWidth
                  defaultValue={attribute.staticAttributeValue}
                  onChange={event => {
                    this.handleReportAttributeChange(
                      event.target.value,
                      "staticAttributeValue",
                      childIndex
                    );
                  }}
                />
              </div>
            ) : (
              <div className={"col-xs conf-seer"} style={{ padding: "3px" }}>
                <FormControl
                  key={"FormPontName" + childIndex}
                  style={{ width: "100%" }}
                >
                  <Autocomplete
                    disabled={!IsEditable}
                    id={
                      "disable-close-on-select" +
                      attribute.pointListId +
                      parentIndex +
                      childIndex
                    }
                    defaultValue={attribute.pointDisplayName}
                    options={this.state.pointList.map(a => a.pointDisplayName)}
                    // getOptionLabel={(option) => option.pointDisplayName}
                    onChange={(event, newValue) => {
                      // console.log(newValue);
                      const point = this.state.pointList.find(
                        x => x.pointDisplayName == newValue
                      );

                      this.handleReportAttributeChange(
                        point.pointDisplayName,
                        "pointDisplayName",
                        childIndex
                      );
                      this.handleReportAttributeChange(
                        point.pointListId,
                        "pointListId",
                        childIndex
                      );
                    }}
                    renderInput={params => (
                      <TextField
                        disabled={!IsEditable}
                        {...params}
                        label={"Select Point"}
                        margin={"normal"}
                        size={"small"}
                      />
                    )}
                  />
                </FormControl>
              </div>
            )}

            <div className={"col-xs"} style={{ padding: "3px" }}>
              <FormControl
                key={"FormServiceLocation" + childIndex}
                style={{ width: "100%" }}
              >
                <InputLabel
                  size={"small"}
                  id={"serviceLocationLabel" + childIndex}
                  key={"LabelKeyServiceLocation" + childIndex}
                >
                  {"Data Hall\r"}
                </InputLabel>
                <Select
                  disabled={!IsEditable}
                  required
                  labelId={"serviceLocationLabel" + childIndex}
                  id={"serviceLocationSelect" + childIndex}
                  value={attribute.serviceLocationId || 0}
                  placeholder={"Select service Location"}
                  onChange={event => {
                    this.handleReportAttributeChange(
                      event.target.value,
                      "serviceLocationId",
                      childIndex
                    );
                  }}
                >
                  <MenuItem
                    size={"medium"}
                    key={"locationMenu" + "em" + childIndex}
                    value={0}
                  >
                    {"None\r"}
                  </MenuItem>
                  {serviceLocationsList.map((dc, index) => (
                    <MenuItem
                      size={"medium"}
                      key={"locationMenu" + index + "ch" + childIndex}
                      value={dc.serviceLocationId}
                      title={dc.serviceLocation}
                    >
                      {dc.abbreviation}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={"col-xs"} style={{ padding: "3px" }}>
              <FormControl
                key={"FormServiceSide" + childIndex}
                style={{ width: "100%" }}
              >
                <InputLabel
                  size={"small"}
                  id={"serviceSideLabel" + childIndex}
                  key={"LabelKeyServiceSide" + childIndex}
                >
                  {"Side\r"}
                </InputLabel>
                <Select
                  disabled={!IsEditable}
                  required
                  labelId={"serviceSideLabel" + childIndex}
                  id={"serviceSideSelect" + childIndex}
                  value={attribute.serviceSideId || 0}
                  placeholder={"Select service side"}
                  onChange={event => {
                    this.handleReportAttributeChange(
                      event.target.value,
                      "serviceSideId",
                      childIndex
                    );
                  }}
                >
                  <MenuItem
                    size={"medium"}
                    key={"sideMenu" + "em" + childIndex}
                    value={0}
                  >
                    {"None\r"}
                  </MenuItem>
                  {serviceLocationSideList.map((dc, index) => (
                    <MenuItem
                      size={"medium"}
                      key={"sideMenu" + index + "ch" + childIndex}
                      value={dc.serviceSideId}
                    >
                      {dc.serviceSide}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={"col-xs"} style={{ padding: "3px" }}>
              <FormControl
                key={"FormOperator" + childIndex}
                style={{ width: "100%" }}
              >
                <InputLabel
                  size={"small"}
                  id={"OperatorLabel" + childIndex}
                  key={"LabelKeyOperator" + childIndex}
                >
                  {"Operator\r"}
                </InputLabel>
                <Select
                  disabled={!IsEditable}
                  required
                  labelId={"OperatorLabel" + childIndex}
                  id={"OperatorSelect" + childIndex}
                  value={attribute.operatorId || 0}
                  placeholder={"Select Operator"}
                  onChange={event => {
                    this.handleReportAttributeChange(
                      event.target.value,
                      "operatorId",
                      childIndex
                    );
                  }}
                >
                  <MenuItem
                    size={"medium"}
                    key={"sideMenu" + "em" + childIndex}
                    value={0}
                  >
                    {"Select\r"}
                  </MenuItem>
                  {operatorList.map((dc, index) => (
                    <MenuItem
                      size={"medium"}
                      key={"operatorMenu" + index}
                      value={dc.operatorId}
                    >
                      {dc.operatorName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {attribute.operatorId == 4 || attribute.operatorId == 7 ? (
              attribute.isCalculationBasedOnAttribute == true ? (
                <div className={"col-xs"} style={{ padding: "3px" }}>
                  <FormControl
                    key={"calculationAttributeTable" + childIndex}
                    style={{ width: "100%" }}
                  >
                    <InputLabel
                      size={"small"}
                      id={"calculationAttributeLabel" + childIndex}
                      key={"calculationAttributeTable" + childIndex}
                    >
                      {"Calculate on\r"}
                    </InputLabel>
                    <Select
                      disabled={!IsEditable}
                      required
                      labelId={"calculationAttributeLabel" + childIndex}
                      id={"calculationAttributeSelect" + childIndex}
                      value={attribute.calculationAttributeId || 0}
                      placeholder={"Select Calculation field"}
                      onChange={event => {
                        this.handleReportAttributeChange(
                          event.target.value,
                          "calculationAttributeId",
                          childIndex
                        );
                      }}
                    >
                      <MenuItem
                        size={"medium"}
                        key={"calculationAttributeMenu" + "em" + childIndex}
                        value={0}
                      >
                        {"None\r"}
                      </MenuItem>
                      {calculationFieldAttributes.map((dc, index) => (
                        <MenuItem
                          size={"medium"}
                          key={
                            "calculationAttributeMenu" +
                            index +
                            "ch" +
                            childIndex
                          }
                          value={dc.attributeListId}
                        >
                          {dc.attributeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              ) : (
                <div className={"col-xs conf-seer"} style={{ padding: "3px" }}>
                  <FormControl
                    key={"FormCalcPointName" + childIndex}
                    style={{ width: "100%" }}
                  >
                    <Autocomplete
                      disabled={!IsEditable}
                      id={
                        "calcDisable-close-on-select" +
                        attribute.pointListId +
                        parentIndex +
                        childIndex
                      }
                      defaultValue={pointCalculationAttributeDisplayName}
                      options={this.state.pointList.map(
                        a => a.pointDisplayName
                      )}
                      // getOptionLabel={(option) => option.pointDisplayName}
                      onChange={(event, newValue) => {
                        // console.log(newValue);
                        const point = this.state.pointList.find(
                          x => x.pointDisplayName == newValue
                        );

                        this.handleReportAttributeChange(
                          point.pointListId,
                          "calculationAttributeId",
                          childIndex
                        );
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label={"Select Point"}
                          margin={"normal"}
                          size={"small"}
                        />
                      )}
                    />
                  </FormControl>
                </div>
              )
            ) : null}

            {attribute.isLookup && (
              <>
                <div className={"col-xs"} style={{ padding: "3px" }}>
                  <FormControl
                    key={"FormLookupTable" + childIndex}
                    style={{ width: "100%" }}
                  >
                    <InputLabel
                      size={"small"}
                      id={"FormLookupTableLabel" + childIndex}
                      key={"LabelKeyFormLookupTable" + childIndex}
                    >
                      {"Look up Table\r"}
                    </InputLabel>
                    <Select
                      disabled={!IsEditable}
                      required
                      labelId={"FormLookupTableLabel" + childIndex}
                      id={"FormLookupTableSelect" + childIndex}
                      value={attribute.lookupTableId || 0}
                      placeholder={"Select Look up Master"}
                      onChange={event => {
                        this.handleReportAttributeChange(
                          event.target.value,
                          "lookupTableId",
                          childIndex
                        );
                      }}
                    >
                      <MenuItem
                        size={"medium"}
                        key={"FormLookupTableMenu" + "em" + childIndex}
                        value={0}
                      >
                        {"None\r"}
                      </MenuItem>
                      {performanceLookUpMasterTables.map((dc, index) => (
                        <MenuItem
                          size={"medium"}
                          key={
                            "FormLookupTableMenu" + index + "ch" + childIndex
                          }
                          value={dc.performanceLkpMasterId}
                        >
                          {dc.tableName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={"col-xs"} style={{ padding: "3px" }}>
                  <FormControl
                    key={"LookupOnField" + childIndex}
                    style={{ width: "100%" }}
                  >
                    <InputLabel
                      size={"small"}
                      id={"LookupOnFieldLabel" + childIndex}
                      key={"LabelKeyLookupOnField" + childIndex}
                    >
                      {"Look up on\r"}
                    </InputLabel>
                    <Select
                      disabled={!IsEditable}
                      required
                      labelId={"LookupOnFieldLabel" + childIndex}
                      id={"FLookupOnFieldSelect" + childIndex}
                      value={attribute.lookupOnFieldId || 0}
                      placeholder={"Select Look up on"}
                      onChange={event => {
                        this.handleReportAttributeChange(
                          event.target.value,
                          "lookupOnFieldId",
                          childIndex
                        );
                      }}
                    >
                      <MenuItem
                        size={"medium"}
                        key={"LookupOnFieldMenu" + "em" + childIndex}
                        value={0}
                      >
                        {"None\r"}
                      </MenuItem>
                      {(
                        performanceLookUpAttributes.filter(
                          x =>
                            x.performanceLkpMasterId == attribute.lookupTableId
                        ) || []
                      ).map((dc, index) => (
                        <MenuItem
                          size={"medium"}
                          key={"LookupOnFieldMenu" + index + "ch" + childIndex}
                          value={dc.performanceLkpAttributeId}
                        >
                          {dc.attributeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className={"col-xs"} style={{ padding: "3px" }}>
                  <FormControl
                    key={"LookupField" + childIndex}
                    style={{ width: "100%" }}
                  >
                    <InputLabel
                      size={"small"}
                      id={"LookupFieldIdLabel" + childIndex}
                      key={"LabelKeyLookupFieldId" + childIndex}
                    >
                      {"Look up value\r"}
                    </InputLabel>
                    <Select
                      disabled={!IsEditable}
                      required
                      labelId={"LookupFieldIdLabel" + childIndex}
                      id={"LookupFieldIdSelect" + childIndex}
                      value={attribute.lookupFieldId || 0}
                      placeholder={"Select Look up value"}
                      onChange={event => {
                        this.handleReportAttributeChange(
                          event.target.value,
                          "lookupFieldId",
                          childIndex
                        );
                      }}
                    >
                      <MenuItem
                        size={"medium"}
                        key={"LookupFieldMenu" + "em" + childIndex}
                        value={0}
                      >
                        {"None\r"}
                      </MenuItem>
                      {(
                        performanceLookUpAttributes.filter(
                          x =>
                            x.performanceLkpMasterId == attribute.lookupTableId
                        ) || []
                      ).map((dc, index) => (
                        <MenuItem
                          size={"medium"}
                          key={"LookupFieldMenu" + index + "ch" + childIndex}
                          value={dc.performanceLkpAttributeId}
                        >
                          {dc.attributeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}
            <div className={"w-5"} style={{ padding: "3px", textAlign: "right" }}>
              {IsDeletable ? (
                <IconButton aria-label={"delete"}>
                  <DeleteIcon
                    fontSize={"small"}
                    onClick={() => this.handelDelete(childIndex, "index")}
                  />
                </IconButton>
              ) : null}
              {isLastRow && IsEditable ? (
                <IconButton aria-label={"Add new Attribute"}>
                  <AddBoxIcon
                    fontSize={"small"}
                    onClick={() =>
                      this.addNewAttribute(
                        attribute.attributeName,
                        attribute.attributeListId,
                        attribute.isStatic,
                        attribute.isLookup,
                        attribute.isCalculationBasedOnAttribute,
                        childIndex + 1
                      )}
                  />
                </IconButton>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  };

  /**
   * save historical button on save click
   * @returns 
   */
  SaveHistoricalData = () => {
    const {
      selectedDatacenter,
      selectedReportId,
      historicalStartDate,
      historicalEndDate
    } = this.state;

    if (
      moment(historicalStartDate).isValid() == false ||
      moment(historicalEndDate).isValid() == false
    ) {
      ShowToast(
        "Invalid dates. Please select correct dates",
        toastType.ERROR,
        5000,
        500
      );
      return;
    }

    if (moment(historicalStartDate) > moment(historicalEndDate)) {
      ShowToast(
        "Invalid dates. Start date should be less than End date",
        toastType.ERROR,
        5000,
        501
      );
      return;
    }
    if (moment(historicalEndDate) > moment(new Date())) {
      ShowToast("Future date is not allowed.", toastType.ERROR, 5000, 502);
      return;
    }
    const params = {
      reportId: selectedReportId,
      propertyId: selectedDatacenter,
      startDate: moment(historicalStartDate).format("MM-DD-YYYY"),
      endDate: moment(historicalEndDate).format("MM-DD-YYYY")
    };
    ShowToast("Request queued successfully.", toastType.SUCCESS, 5000, 50);

    apiRequestAsync({
      url: API_URL.performance.LoadPerformanceAttributeHistoricalData,
      params: params
    }).then(() => {
      // if (response.success) {
      //   ShowToast(
      //     "Loading of historical data completed successfully.",
      //     toastType.SUCCESS,
      //     5000,
      //     501
      //   );
      // } else {
      //   ShowToast(
      //     "Unable to load historical data." + response.message,
      //     toastType.ERROR,
      //     5000,
      //     502
      //   );
      // }
    });
    this.setState({
      isLoadHistoryOpen: false,
      historicalEndDate: undefined,
      historicalStartDate: undefined,
      selectedReportName: "",
      selectedReportId: 0
    });
  };
  
  render() {
    const {
      isInEditView,
      isLoadHistoryOpen,
      historicalStartDate,
      historicalEndDate,
      selectedReportName
    } = this.state;

    return (
      <>
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                style={{ display: "flex", height: "auto" }}
              >
                <div className={"content-header"} style={{ height: "auto" }}>
                  {isInEditView && (
                    <div
                      className={"col-xs-1"}
                      style={{ display: "inline-block", float: "left" }}
                    >
                      <IconButton
                        className={"white-button"}
                        color={"inherit"}
                        size={"small"}
                        onClick={() => {
                          this.setState({
                            isInEditView: false,
                            selectedReportId: 0
                          });
                        }}
                      >
                        <BackIcon
                          className={"white-button"}
                          style={{ fill: "white !important" }}
                          fontSize={"small"}
                        />
                      </IconButton>
                    </div>
                  )}{" "}
                  {"Facility Performance Views Configuration\r"}
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          {this.renderBody()}
        </Table>
        <Dialog
          fullScreen={false}
          open={isLoadHistoryOpen}
          onClose={() => this.setState({ isLoadHistoryOpen: false })}
          aria-labelledby={"responsive-dialog-title"}
          className={"history-dialog"}
        >
          <DialogTitle id={"responsive-dialog-title"}>{"Confirm"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {"Are you sure you want to load Historical Data for"}{" "}
              {selectedReportName}{"? if yes then please select date range and\r"}
              {"click on Agree.\r"}
            </DialogContentText>
            <div className={"row"}>
              <div className={"col-xs"}>
                <DatePicker
                  selected={historicalStartDate}
                  onChange={date =>
                    this.setState({ historicalStartDate: date })}
                  placeholderText={"select from date"}
                />
              </div>
              <div className={"col-xs"}>
                <DatePicker
                  selected={historicalEndDate}
                  onChange={date => this.setState({ historicalEndDate: date })}
                  placeholderText={"select to date"}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() =>
                this.setState({
                  isLoadHistoryOpen: false,
                  historicalEndDate: undefined,
                  historicalStartDate: undefined
                })}
              color={"primary"}
            >
              {"Cancel\r"}
            </Button>
            <Button
              onClick={() => {
                this.SaveHistoricalData(true);
              }}
              color={"primary"}
              autoFocus
            >
              {"Agree\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
